export const ToggleTypeDefaultValues = ['Sensitivity', 'VaR', 'Stress Test'];
export const ParametersDefaultOptions = ['Standalone', 'Allocated', 'Marginal'];
export const SearchAbleMockOptions = ['Standard Dev', '95%', '99%'];
